import _extends from "@babel/runtime/helpers/extends";
import { BoxSelection as TPABoxSelection } from 'wix-ui-tpa/cssVars';
import { formatCurrency } from '../../utils/format-currency';
import React from 'react';
import { useConfig } from '../../contexts/config-context';
export const DonationFieldOptionWUT = props => {
  const {
    currency,
    locale
  } = useConfig();
  const optionRef = /*#__PURE__*/React.createRef();
  const {
    price,
    ...optionProps
  } = props;
  return /*#__PURE__*/React.createElement(TPABoxSelection.Option, _extends({}, optionProps, {
    ref: optionRef
  }), price ? formatCurrency(price, currency == null ? void 0 : currency.code, locale) : '');
};
//# sourceMappingURL=donation-field-option-wut.js.map